// @flow

import React, { type Node } from 'react';
import { useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import {getSafePreTokenizedCard} from '../../../../../../prs/incoming-payment/get-pre-tokenized-card';
import vrBrandSrc from '@tectonics/commons/look-and-feel/uber/asset/image/vr.svg';

export function VrDisplayName(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const preTokenizedCard = getSafePreTokenizedCard(incomingPayment);

  return (
    <div style={{ padding: '1em', display: 'flex', justifyContent: 'center' }}>
      <img src={vrBrandSrc} alt="Logo VR" style={{ paddingRight: '1em' }} />
      <p style={{
        fontWeight: 'bold',
        fontSize: '20px',
        fontFamily: 'Gilroy, sans-serif',
      }}>•••• •••• •••• {preTokenizedCard.last_four}</p>
    </div>
  );
}
